import React, { useState, useEffect } from 'react';
import { User } from 'lucide-react';
import { BACKEND_URL } from '../services/api';

const StudentAvatar = ({ photoUrl, fullName, className = "w-10 h-10 rounded-xl" }) => {
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    setImgError(false);
  }, [photoUrl]);

  if (photoUrl && !imgError) {
    const srcUrl = photoUrl.startsWith('http://') || photoUrl.startsWith('https://') 
      ? photoUrl 
      : `${BACKEND_URL}${photoUrl}`;
    return (
      <img
        src={srcUrl}
        alt={fullName || 'Student'}
        onError={() => setImgError(true)}
        className={`${className} object-cover border-2 border-white shadow-sm shrink-0`}
      />
    );
  }

  const initials = fullName
    ? fullName
        .split(' ')
        .map((n) => n[0])
        .slice(0, 2)
        .join('')
        .toUpperCase()
    : '';

  return (
    <div className={`${className} bg-indigo-50 text-indigo-400 flex items-center justify-center border border-indigo-100 shrink-0 font-bold`}>
      {initials || <User size={18} />}
    </div>
  );
};

export default StudentAvatar;
